
import { defineComponent } from 'vue'
import IconLoading from '@/components/atoms/IconLoading.vue'

export default defineComponent({
  components: {
    IconLoading,
  },
})
